import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rOyakEmlakVergileri } from '../../../../api/models/rOyakEmlakVergileri';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rOyakEmlakVergileri>,
  rOyakEmlakVergileri
>(ActionSubTypes.API_OYAKEMLAKVERGILERI, DefaultInputDataStateModel<pList, rOyakEmlakVergileri>());
